import { render, staticRenderFns } from "./PlayerClientPayments.vue?vue&type=template&id=b4671e64&scoped=true&"
import script from "./PlayerClientPayments.vue?vue&type=script&lang=js&"
export * from "./PlayerClientPayments.vue?vue&type=script&lang=js&"
import style0 from "./PlayerClientPayments.vue?vue&type=style&index=0&id=b4671e64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4671e64",
  null
  
)

export default component.exports